import { ApolloError } from 'apollo-client';
import { resetAuthToken, resetUserObject } from './../data/api/client/authToken';
import { GraphQLError } from 'graphql';



export function handleExpiredJWT(error: ApolloError, callbackOnExpiredJwt: Function): GraphQLError[] {
    if (!error) {
        console.log('The passed value passed to (error: ApolloError) was null or undefined.');
        return;
    }
    let nonJwtExpErrors: GraphQLError[] = [];
    error.graphQLErrors.forEach((error: GraphQLError) => {
        console.log({ error });
        if (error.extensions.code === 'invalid-jwt') {
            console.log(`JWT HAS EXPIRED OR IS INVALID ${error.message}`);
            resetAuthToken();
            resetUserObject();
            callbackOnExpiredJwt();
        }
        else {
            nonJwtExpErrors.push({...error});
        }
    });

    return nonJwtExpErrors;
}
